module.exports = __webpack_public_path__ + "img/fish1.89f4ca12.png";